import React from 'react';
import { useAuth } from 'hooks/useAuth';

const OfflineIndicator = () => {
  const { isOffline } = useAuth();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#e53935',
        color: 'white',
        padding: '8px 16px',
        textAlign: 'center',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      <div>You are offline.</div>
      {/* <button
        onClick={toggleOfflineMode}
        style={{
          backgroundColor: offlineMode ? '#f57c00' : '#d32f2f',
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        {offlineMode ? 'Exit Offline Mode' : 'Enable Offline Mode'}
      </button> */}
    </div>
  );
};

export default OfflineIndicator;
